/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenu_filters = ReadonlyArray<{
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilters_filters" | "SbSharedRefineMenuDisplayPrefsSelect_filters">;
    readonly " $refType": "SbRespRefineMenu_filters";
}>;
export type SbRespRefineMenu_filters$data = SbRespRefineMenu_filters;
export type SbRespRefineMenu_filters$key = ReadonlyArray<{
    readonly " $data"?: SbRespRefineMenu_filters$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_filters">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbRespRefineMenu_filters",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_filters"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_filters"
    }
  ],
  "type": "SearchBrowseFilter",
  "abstractKey": null
};
(node as any).hash = 'fbe4a3afa9de14b2bf5167e3b6714133';
export default node;
